import { API_URL } from '../../config/env';
import { Injectable } from '../../decorators/injectable';
import { InviteError } from '../invite/invite.service';
import type {
  AdminInviteDetails,
  AdminInviteMagicLinkResponse,
  IAdminInvitePublicService,
} from './admin-invite-public.service.interface';

@Injectable()
export class AdminInvitePublicService implements IAdminInvitePublicService {
  private readonly baseUrl: string;

  constructor() {
    this.baseUrl = API_URL.endsWith('/') ? API_URL : `${API_URL}/`;
  }

  async getByToken(token: string): Promise<AdminInviteDetails> {
    const response = await fetch(`${this.baseUrl}admin-invite/${encodeURIComponent(token)}`);
    if (!response.ok) {
      const code = await extractErrorCode(response);
      throw new InviteError(
        `Admin invite request failed: ${response.status}`,
        response.status,
        code,
      );
    }
    return response.json();
  }

  async createMagicLink(token: string): Promise<AdminInviteMagicLinkResponse> {
    const response = await fetch(
      `${this.baseUrl}admin-invite/${encodeURIComponent(token)}/magic-link`,
      { method: 'POST' },
    );
    if (!response.ok) {
      const code = await extractErrorCode(response);
      throw new InviteError(`Magic link failed: ${response.status}`, response.status, code);
    }
    return response.json();
  }
}

// ponytail: response body may be empty (e.g. network-layer 410) — code extraction is best-effort
async function extractErrorCode(response: Response): Promise<string | undefined> {
  try {
    const body = await response.json();
    return typeof body?.code === 'string' ? body.code : undefined;
  } catch {
    return undefined;
  }
}
